<template>
  <div class="mandatory-comments">
    <div class="mandatory-comments__content">
      <div v-for="(val, key) in mandatoryCommentProxy" :key="key" class="mandatory-comments__section">
        <p>{{ tStatic('articleNumber') }}: {{ key }}</p>
        <oie-base-input
          v-for="comment in val"
          :key="comment.key"
          v-model="comment.value"
          :label-text="comment.title"></oie-base-input>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    mandatoryCommentProxy: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style lang="scss">
.mandatory-comments > *:not(:last-child),
.mandatory-comments__content > *:not(:last-child) {
    margin-bottom: measure(full);
}

.mandatory-comments__content {
  padding: measure(half);
  background-color: color(background-yellow);
  border: 1px solid color(border-yellow);
}

.mandatory-comments__section {
  display: flex;
  flex-direction: column;
  gap: measure(half);
}
</style>
